var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faSearch, faTimes, faCheckCircle, } from "@fortawesome/pro-regular-svg-icons";
import { getCookie, setCookie } from "react-simple-cookie-store";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DrawerGroup } from "./DrawerGroup";
import { DrawerItem } from "./DrawerItem";
import { IconButton } from "../Navigation";
import { Button } from "../Form";
import { Input } from "../Form";
import { DRAWER_GROUP_TYPE, } from "./types";
import clsx from "clsx";
import { DrawerBackground } from "./DrawerBackground";
import { DraggableEdge } from "./DraggableEdge";
import { useBreakpoint } from "utils";
import * as Indicators from "../Indicators";
import { swallow } from "utils";
export var DRAWER_EDGE_ITEM_TYPE = "DrawerEdgeItem";
var WIDTH_COOKIE = "drawerWidth";
var DRAWER_STYLES = "flex flex-col bg-white h-full relative shadow-lg";
var BAR_TEXT_COLOR = "text-lochivar-dark";
var BAR_STYLES = "flex border-b border-lochivar-default border-opacity-25 bg-lochivar-default bg-opacity-5 p-1";
export var Drawer = function (_a) {
    var _b;
    var title = _a.title, items = _a.items, handleSort = _a.onSort, handleSearch = _a.onSearch, handleNewClick = _a.onNewClick, handleNewGroupClick = _a.onNewGroupClick, handleDismiss = _a.onDismiss, handleToggleGroup = _a.onToggleGroup, onContextMenu = _a.onContextMenu, newItemLabel = _a.newItemLabel, offset = _a.offset, loading = _a.loading;
    var _c = useState(null), altAction = _c[0], setAltAction = _c[1];
    var _d = useState(parseInt((_b = getCookie(WIDTH_COOKIE)) !== null && _b !== void 0 ? _b : "425")), width = _d[0], setWidth = _d[1];
    var _e = useState(""), search = _e[0], setSearch = _e[1];
    var handleChange = function (e) {
        var searchText = e.currentTarget.value;
        setSearch(searchText);
        handleSearch === null || handleSearch === void 0 ? void 0 : handleSearch(searchText);
    };
    var breakpoints = useBreakpoint();
    var searchInput = useRef(null);
    useEffect(function () {
        var _a;
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (altAction !== "search") {
            setSearch("");
            handleSearch === null || handleSearch === void 0 ? void 0 : handleSearch("");
        }
    }, [searchInput.current, altAction]);
    var toggleAction = function (action) { return function () {
        setAltAction(action);
    }; };
    var sortable = altAction === "sort";
    var truncationLength = Math.round((width - 100) / 7);
    var renderTree = function (groupId, indent) {
        var indentedTruncationLength = truncationLength
            ? truncationLength - (indent !== null && indent !== void 0 ? indent : 0) * 5
            : undefined;
        return (_jsx("ul", __assign({ className: "flex flex-col w-full" }, { children: items
                .filter(function (i) { return (groupId ? i.groupId === groupId : !i.groupId); })
                .map(function (_a) {
                var id = _a.id, item = __rest(_a, ["id"]);
                var isGroup = item.type === DRAWER_GROUP_TYPE;
                var selectGroup = function (e) {
                    var _a;
                    e.preventDefault();
                    handleToggleGroup === null || handleToggleGroup === void 0 ? void 0 : handleToggleGroup(id, !((_a = item.open) !== null && _a !== void 0 ? _a : false));
                };
                var renderContent = function () {
                    return isGroup ? (_jsx(DrawerGroup, __assign({}, item, { id: id, sortable: sortable, indent: indent, onSelect: selectGroup, onSort: handleSort, onContextMenu: onContextMenu, truncationLength: indentedTruncationLength }), void 0)) : (_jsx(DrawerItem, __assign({}, item, { id: id, sortable: sortable, indent: indent, onSort: handleSort, onContextMenu: onContextMenu, truncationLength: indentedTruncationLength }), void 0));
                };
                var canRenderSubtree = id &&
                    isGroup &&
                    item.open &&
                    item.id !== id &&
                    (indent !== null && indent !== void 0 ? indent : 0) < 20;
                return (_jsxs(React.Fragment, { children: [renderContent(), canRenderSubtree ? renderTree(id, (indent !== null && indent !== void 0 ? indent : 0) + 1) : null] }, id));
            }) }), void 0));
    };
    var handleDragOver = useCallback(function (delta) {
        var newWidth = Math.min(Math.max(delta - (offset !== null && offset !== void 0 ? offset : 0), 225), 768);
        setWidth(newWidth);
        setCookie(WIDTH_COOKIE, newWidth.toString(), 365);
    }, [width, setWidth]);
    var focusSearch = function () {
        var _a;
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var stopClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    return (_jsx(DrawerBackground, __assign({ onClick: handleDismiss, onDragOver: handleDragOver }, { children: _jsxs("div", __assign({ className: DRAWER_STYLES, style: {
                width: breakpoints.includes("md") ? width : "100%",
                left: offset,
            }, onClick: stopClick }, { children: [loading ? _jsx(Indicators.AbsoluteOverlay, {}, void 0) : null, _jsx(DraggableEdge, {}, void 0), _jsxs("header", { children: [altAction === "sort" ? (_jsxs("div", __assign({ className: clsx(BAR_TEXT_COLOR, BAR_STYLES) }, { children: [_jsx("h3", __assign({ className: "my-auto font-bold mr-auto ml-2" }, { children: "Drag and drop to sort" }), void 0), _jsx(Button, __assign({ onClick: swallow(toggleAction(null)), appearance: "link", className: "my-auto mx-2" }, { children: _jsx("span", __assign({ className: "mx-auto" }, { children: "Done" }), void 0) }), void 0), _jsx(IconButton, { onClick: toggleAction(null), icon: faCheckCircle, tooltip: "Done", className: "my-auto" }, void 0)] }), void 0)) : null, altAction ? null : (_jsxs("ul", __assign({ className: clsx(BAR_TEXT_COLOR, BAR_STYLES) }, { children: [handleSearch ? (_jsx("li", __assign({ className: "flex mr-1" }, { children: _jsx(IconButton, { icon: faSearch, onClick: focusSearch, tooltip: "search", className: "my-auto" }, void 0) }), void 0)) : null, _jsx("li", __assign({ className: "flex flex-grow my-auto mr-auto text-small font-bold" }, { children: _jsx(Input, { placeholder: "search " + title.toLowerCase() + "...", onChange: handleChange, value: search, name: "searchText", className: "w-full mx-1", ref: searchInput }, void 0) }), void 0), handleSort ? (_jsx("li", __assign({ className: "flex" }, { children: _jsx(Button, __assign({ onClick: swallow(toggleAction("sort")), appearance: "link", className: "my-auto mx-1" }, { children: _jsx("span", __assign({ className: "mx-auto" }, { children: "Sort" }), void 0) }), void 0) }), void 0)) : null, handleDismiss ? (_jsx("li", __assign({ className: "flex" }, { children: _jsx(IconButton, { icon: faTimes, onClick: handleDismiss, tooltip: "close", className: "my-auto" }, void 0) }), void 0)) : null] }), void 0))] }, void 0), _jsx("div", __assign({ className: "flex-grow relative" }, { children: _jsxs("nav", __assign({ className: "absolute inset-0 overflow-y-auto" }, { children: [handleNewClick || handleNewGroupClick ? (_jsxs("header", __assign({ className: "flex p-2 border-b border-gray-200 sticky top-0 bg-white z-10" }, { children: [handleNewClick ? (_jsx(Button, __assign({ onClick: handleNewClick, className: "mr-1 flex flex-grow flex-shrink-0" }, { children: _jsx("span", __assign({ className: "mx-auto" }, { children: newItemLabel !== null && newItemLabel !== void 0 ? newItemLabel : "Add Item" }), void 0) }), void 0)) : null, handleNewGroupClick ? (_jsx(Button, __assign({ onClick: handleNewGroupClick, className: "ml-1 flex flex-grow flex-shrink-0" }, { children: _jsx("span", __assign({ className: "mx-auto" }, { children: "New Group" }), void 0) }), void 0)) : null] }), void 0)) : null, renderTree()] }), void 0) }), void 0)] }), void 0) }), void 0));
};
